import { z } from 'zod';
// Roles on a Telegram allowlist entry:
//   admin  → receives push notifications AND can query the bot
//   viewer → can query the bot, but is not pushed notifications
export const TELEGRAM_RECIPIENT_ROLES = ['admin', 'viewer'];
export const TELEGRAM_RECIPIENT_ROLE_LABELS = {
    admin: 'Admin · gets notifications + can query',
    viewer: 'Viewer · can query only',
};
// A Telegram chat id is a signed integer ("-" prefix for groups/channels),
// treated opaquely. Cap the length defensively — real ids are well under this.
export const telegramChatIdSchema = z
    .string()
    .trim()
    .regex(/^-?\d{1,32}$/, 'Must be a numeric Telegram chat id');
// Validated input for adding/updating a recipient. Shared by the admin form
// (zodResolver) and the API route (safeParse).
export const telegramRecipientInputSchema = z.object({
    chat_id: telegramChatIdSchema,
    role: z.enum(TELEGRAM_RECIPIENT_ROLES),
    label: z
        .string()
        .trim()
        .min(1)
        .max(200)
        .optional()
        .or(z.literal('').transform(() => undefined)),
});
//# sourceMappingURL=telegram.js.map